import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment2aModel } from "../state";


interface Assessment2aDownloadCSVProps {
    model: Assessment2aModel;
}

function Assessment2aDownloadCSV({ model }: Assessment2aDownloadCSVProps) {

    
    const csvData = [["Issue", "Action Plan"]];
        let rowIndex:number = 1;
        if(model.requestDataMinVendorsDesc	 !== null && model.requestDataMinVendorsDesc !== '')
        {
            csvData[rowIndex] = ["You must request data from the required number of electric vendors. Since there are at least five electricity vendors in your state who serve LIHEAP clients, this means you must request and receive data from at least five electric vendors. Please indicate your plans to address this issue in the box below."
                                  , model.requestDataMinVendorsDesc];
            rowIndex++; 
        }
        if(model.vendorAgreementsHaveDataCollectionReqDesc	 !== null && model.vendorAgreementsHaveDataCollectionReqDesc !== '')
        {
            csvData[rowIndex] = ["Do your vendor agreements with electric vendors include data collection requirements?"
                                  , model.vendorAgreementsHaveDataCollectionReqDesc];
            rowIndex++; 
        }
        if(model.clientWaiversMeetVendorRequirementsDesc	 !== null && model.clientWaiversMeetVendorRequirementsDesc !== '')
        {
            csvData[rowIndex] = ["Do your client waivers satisfy electric vendors' privacy standards for sharing client data?"
                                  , model.clientWaiversMeetVendorRequirementsDesc];
            rowIndex++; 
        }
        if(model.vendorsAlertedTimelyMannerDesc	 !== null && model.vendorsAlertedTimelyMannerDesc !== '')
        {
            csvData[rowIndex] = ["Do you send data requests out to your vendors as soon as possible after the end of the Federal Fiscal Year in order to give them ample time to respond before the reporting deadline? "
                                  , model.vendorsAlertedTimelyMannerDesc];
            rowIndex++; 
        }
        if(model.deliveredFuelSmallElectricVendorDesc	 !== null && model.deliveredFuelSmallElectricVendorDesc !== '')
        {
            csvData[rowIndex] = ["Need to know if more than half of your delivered fuel (Fuel Oil and Propane) households receive their baseload electric service from a small electric vendor that is not in your top 5."
                                  , model.deliveredFuelSmallElectricVendorDesc];
            rowIndex++; 
        }
        if(model.smallElectricVendorCollectDataDesc	 !== null && model.smallElectricVendorCollectDataDesc !== '')
        {
            csvData[rowIndex] = ["Plan to collect data from small electric vendors."
                                  , model.smallElectricVendorCollectDataDesc];
            rowIndex++; 
        }
        if(model.otherReasonDesc	 !== null && model.otherReasonDesc !== '')
        {
            csvData[rowIndex] = ["Plans to remedy data collection issues."
                                  , model.otherReasonDesc];
            rowIndex++; 
        }
        if(model.publicMuniplanRequestDataDesc	 !== null && model.publicMuniplanRequestDataDesc !== '')
        {
            csvData[rowIndex] = ["Please indicate your plans for requesting data from public municipal utilities."
                                  , model.publicMuniplanRequestDataDesc];
            rowIndex++; 
        }
        if(model.ruralCoopplanRequestDataDesc	 !== null && model.ruralCoopplanRequestDataDesc !== '')
        {
            csvData[rowIndex] = ["Please indicate your plans for requesting data from electric cooperatives."
                                  , model.ruralCoopplanRequestDataDesc];
            rowIndex++; 
        }
        if(model.investorOwnedUtilplanRequestDataDesc	 !== null && model.investorOwnedUtilplanRequestDataDesc !== '')
        {
            csvData[rowIndex] = ["Please indicate your plans for requesting data from investor owned utilities."
                                  , model.investorOwnedUtilplanRequestDataDesc];
            rowIndex++; 
        }

        
    return (
      <CSVLink data={csvData} filename="ElectricBaseloadAssessment2a.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment2aDownloadCSV;
